import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "sidebar"]
  boundCheckSize = this.checkSize.bind(this)

  connect() {
    this.checkSize()
    window.addEventListener('resize', this.boundCheckSize)
  }

  disconnect() {
    window.removeEventListener('resize', this.boundCheckSize)
  }

  checkSize() {
    // If window is mobile size, ensure menu is hidden by default
    if (window.innerWidth < 1280) {
      this.sidebarTarget.classList.add('-translate-x-full')
      this.overlayTarget.classList.add('hidden')
    } else {
      this.sidebarTarget.classList.remove('-translate-x-full')
      this.overlayTarget.classList.add('hidden')
    }
  }

  toggle(event) {
    // If this toggle is triggered by a link click inside the mobile menu
    // and we're on desktop, we don't want to toggle the menu
    if (event && event.currentTarget.tagName === 'A' && window.innerWidth >= 1280) {
      return
    }

    this.sidebarTarget.classList.toggle('-translate-x-full')
    this.overlayTarget.classList.toggle('hidden')
  }
} 
